import React from "react";

const integrationsData = [
  {
    title: "Armada Online Ordering & Payments",
    description:
      "Launch your own commission-less ordering site and accept secure payments. Orders flow directly to POS and kitchen with unified inventory and customer data.",
  },
  {
    title: "Third-Party Platforms",
    description:
      "Already using delivery apps or marketplaces? Connect them to unify online and in-store sales with accurate stock and pricing control.",
  },
];

const Integrations = () => (
  <section id="integrations" className="py-16 md:py-20 bg-slate-50">
    <div className="max-w-7xl mx-auto px-4">
      <h2 className="text-2xl md:text-3xl font-extrabold">Integrations & Ecosystem</h2>
      <p className="mt-2 text-slate-600 max-w-3xl">
        Extend Armada POS with commission-less online ordering, payments, delivery platforms, accounting, and more.
      </p>

      <div className="mt-8 grid md:grid-cols-2 gap-6">
        {integrationsData.map((item, idx) => (
          <div key={idx} className="rounded-2xl border bg-white p-6 shadow-sm hover:shadow transition">
            <h3 className="font-bold">{item.title}</h3>
            <p className="mt-2 text-slate-700">{item.description}</p>
          </div>
        ))}
      </div>

      <div className="mt-8">
        <a
          href="#signup"
          className="inline-flex items-center rounded-lg px-5 py-3 bg-blue-600 text-white font-semibold hover:bg-blue-700"
        >
          Explore Integrations
        </a>
      </div>
    </div>
  </section>
);

export default Integrations;
